import React, { lazy } from "react";

const CoTraderCombined = lazy(() =>
  import("../Dashboard/CoTrader/CoTraderCombined"),
);
const CoHedgerSummaryDashboardTile = lazy(() =>
  import("../Dashboard/CoHedger/CoHedgerSummaryDashboardTile"),
);
const TradeAnalysis = lazy(() =>
  import("../Dashboard/TradeAnalysis/TradeAnalysis"),
);
const TradingEconomicsCalendar = lazy(() =>
  import("../Dashboard/Calendar/TradingEconomicsCalendar"),
);
const EmbedFxInsights = lazy(() => import("./EmbedFxInsights"));
const EmbedFxGpt = lazy(() => import("./EmbedFxGpt"));
const EmbedMonitor = lazy(() => import("./EmbedMonitor"));

// One entry per standalone screen served at /embed/<key>. `render` receives the
// instrument context ({ type: "fdc3.instrumentList", instruments: [...] }) or null.
// A partner can only launch a key that emgpt's EMBED_SCREEN_PLAN_RULES
// (partner_service.py) maps to a plan, so add new screens there too.
export const EMBED_SCREENS = {
  cotrader: {
    title: "CoTrader",
    render: (context) => <CoTraderCombined instrumentContext={context} />,
  },
  // Single CoTrader tiles, each with its own pair selector.
  fx_insights: {
    title: "FX Insights",
    render: (context) => <EmbedFxInsights context={context} />,
  },
  fx_gpt: {
    title: "Ask EMAlpha",
    render: (context) => <EmbedFxGpt context={context} />,
  },
  cohedger: {
    title: "CoHedger",
    render: (context) => <CoHedgerSummaryDashboardTile context={context} showLogo />,
  },
  trade_analysis: {
    title: "Trade Analysis",
    render: () => <TradeAnalysis />,
  },
  economic_calendar: {
    title: "Economic Calendar",
    render: () => <TradingEconomicsCalendar showLogo />,
  },
  // Agents dashboards, matched by name; filters come from the launch URL.
  macro_monitor: {
    title: "Macro Monitor",
    render: () => <EmbedMonitor monitor="macromonitor" />,
  },
  commodity_monitor: {
    title: "Commodity Monitor",
    render: () => <EmbedMonitor monitor="commoditymonitor" />,
  },
  company_monitor: {
    title: "Company Monitor",
    render: () => <EmbedMonitor monitor="companymonitor" />,
  },
};
